module.exports = __webpack_public_path__ + "img/Falkland Islands (Malvinas).cf221ea3.svg";